import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  dialogTitle: {
    fontSize: 20,
    marginBottom: 10,
  },
  label: {
    marginBottom: 6,
    fontSize: 13,
    fontFamily: 'Red Hat Display',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #ccc',
    fontSize: 14,
    boxSizing: 'border-box',
    marginBottom: 24,
    fontFamily: 'Red Hat Display Light',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
  },
  cancelButton: {
    padding: '8px 20px',
    border: '1px solid #6366f1',
    backgroundColor: '#fff',
    color: '#6366f1',
    borderRadius: 20,
    cursor: 'pointer',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  rejectButton: {
    padding: '8px 20px',
    border: 'none',
    backgroundColor: '#6366f1',
    color: '#fff',
    borderRadius: 20,
    cursor: 'pointer',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#4f4ee9',
    },
  },
}))
